import { defineComponent as _defineComponent } from 'vue'
import {onBeforeMount, ref} from "vue";
import {object} from "yup";
import * as Yup from "yup";
import {Field, Form} from "vee-validate";



export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPasswordStep1',
  props: {
  newPassword: {
    type: Object,
    required: true
  },
},
  emits: ['nextPage', 'prevPage', 'update:newPassword'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

onBeforeMount(() => {
  if (props.newPassword?.email) {
    email.value = props.newPassword.email;
  }
});


const emit = __emit;
const email = ref<string>();

const schema = object().shape({
  email:  Yup.string()
    .email("Invalid format")
    .required( "This field is required"),
});

const next = () => {
  emit('update:newPassword', {...props.newPassword, email: email.value});
  emit('nextPage', {pageIndex: 0});
};


const __returned__ = { props, emit, email, schema, next, get Field() { return Field }, get Form() { return Form } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})